import { Box, styled, type CSSObject } from '@mui/material';

export const PREFIX = 'LatestArticles';

export const classes = {
  root: `${PREFIX}-root`,
  cardArticle: `${PREFIX}-cardArticle`,
  grid: `${PREFIX}-grid`,
  image: `${PREFIX}-image`,
  container: `${PREFIX}-container`,
  articleTitle: `${PREFIX}-articleTitle`,
  cardContainer: `${PREFIX}-cardContainer`,
  pubDateText: `${PREFIX}-pubDateText`,
  button: `${PREFIX}-button`,
  navlink: `${PREFIX}-navlink`,
  imgContainer: `${PREFIX}-imgContainer`,
  textContainer: `${PREFIX}-textContainer`,
  displayNone: `${PREFIX}-displayNone`,
  arrows: `${PREFIX}-arrows`,
  title: `${PREFIX}-title`,
};

export const LatestArticleWrapper = styled(Box)(({ theme }) => ({
  paddingBlock: theme.spacing(4),
  color: theme.palette.common.white,
  [theme.breakpoints.down('md')]: {
    maxWidth: '92vw',
    margin: '0 auto',
  },

  [`& .${classes.grid}`]: {
    marginBottom: '30px',
    textAlign: 'center',
  },

  [`& .${classes.container}`]: {
    marginBottom: theme.spacing(2),
  },

  [`& .${classes.articleTitle}`]: {
    ...(theme.mixins.neutralGradient as CSSObject),
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    position: 'relative !important' as 'relative',
    width: '100%',
    fontSize: '2rem',
    lineHeight: 1,
    paddingBottom: 3,
    textWrap: 'pretty',
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.8rem',
    },
  },

  [`& .${classes.button}`]: {
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      paddingTop: 0,
    },
  },

  [`& .${classes.button}:hover`]: {
    boxShadow: `0px 0px 6px 4px ${theme.palette.raspberryColors?.PLUS_1}, 0px 0px 6px 4px ${theme.palette.raspberryColors?.PLUS_1} inset !important`,
  },

  [`& .${classes.displayNone}`]: {
    display: 'none',
  },

  [`& .${classes.arrows}`]: {
    margin: '0px 30px 0px 30px',
  },

  [`& .${classes.title}`]: {
    margin: '16px 0',
    paddingInline: '32px',
    fontSize: '3rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '2.5rem',
    },
  },
}));
